import { AlertCircle, Check, Clock, UserStar } from 'lucide-react'

import Pill from '@/components/Pill'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Event } from '@/payload-types'

export const StatusIcons = ({
  event,
  isAttending,
  isHost,
  isWaitlisted,
}: {
  event: Event
  isAttending: boolean
  isHost: boolean
  isWaitlisted: boolean
}) => {
  if (!isAttending && !isHost && !isWaitlisted && event.eventStatus !== 'pending') {
    return null
  }

  return (
    <div className="flex items-center gap-2">
      {isAttending && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Pill color="evergreen" size="small">
              <Check className="size-4" />
            </Pill>
          </TooltipTrigger>
          <TooltipContent asChild>
            <span className="block max-w-xs">You are attending this event.</span>
          </TooltipContent>
        </Tooltip>
      )}
      {isWaitlisted && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Pill color="navy" size="small">
              <Clock className="size-4" />
            </Pill>
          </TooltipTrigger>
          <TooltipContent asChild>
            <span className="block max-w-xs">You are waitlisted for this event.</span>
          </TooltipContent>
        </Tooltip>
      )}
      {isHost && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Pill color="outback" size="small">
              <UserStar className="size-4" />
            </Pill>
          </TooltipTrigger>
          <TooltipContent asChild>
            <span className="block max-w-xs">You are a host of this event.</span>
          </TooltipContent>
        </Tooltip>
      )}
      {event.eventStatus === 'pending' && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Pill color="tuscany" size="small">
              <AlertCircle className="size-4" />
            </Pill>
          </TooltipTrigger>
          <TooltipContent asChild>
            <span className="block max-w-xs">
              This event is pending approval and is only visible to hosts. You will be notified when
              the event is approved.
            </span>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  )
}
